import { ADVANCED_CARE_PROGRAM } from "@/core/constants";
import type { PatientConsent } from "@/core/types";

import { adaptPatientConsent } from "./adaptConsent";

/**
 * Get the latest ACP consent record from the list of consents
 */
export function getLatestACPConsent(consents: PatientConsent[]) {
  const latestACPConsent = consents
    /* get consents for the Advanced Care Program */
    .filter((consent) => consent.consent_form_name === ADVANCED_CARE_PROGRAM)
    /* the consents returned from the `get_latest_consents` endpoint are not sorted – we need to sort them by created_date ascending */
    .sort((a, b) => Number(a.created_date) - Number(b.created_date))
    /* get the latest patient consent  */
    ?.at(-1);

  if (!latestACPConsent) return null;

  return adaptPatientConsent(latestACPConsent);
}
